import { MEDIA_QUERIES } from "@/hooks/responsive";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		minWidth: "10rem",
		maxWidth: "30rem",
		width: "23rem",
		...shorthands.padding(tokens.spacingVerticalL, "16px"),

		[`@media ${MEDIA_QUERIES.isMobileMediumToSmall}`]: {
			width: "22rem",
		},
	},
	title: {
		marginBottom: "8px",
	},
	transferType: {
		marginLeft: "-8px",
		marginBottom: "10px",
	},
	transferTargetComboBox: {
		marginBottom: "16px",
	},
	listbox: {
		maxHeight: "350px",
	},
});
